
    import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
    import FormBase from '@/components/helper/form-base.vue';
    import ModalView from '@/components/helper/modal-view.vue';
    import Util from '@/lib/util';
    import ListBase from '@/lib/listbase';
    import Sale from '@/store/entities/cems/sale';

    @Component({
        components: { FormBase, ModalView },
        watch: {
            value: function (val) {
                let obj = (this as any);
                obj.modalShow = val;
                if (val) {
                    obj.sale = Util.extend(true, {}, this.$store.state.sale.editModel);
                    obj.initForm();
                }
            },
            modalShow: function (val) {
                if (!val) {
                    this.$emit('input', false);
                } else {
                    (this as any).initForm();
                }
            }
        }
    })

    export default class SaleForm extends ListBase {
        entity: string = "sale";
        @Prop({ type: Boolean, default: false }) value: boolean;
        sale: Sale = new Sale();
        modalShow: boolean = false;
        tabModel: any = null;
        modalSetting: any = {
            entity: "sale",
            titleFull: 'Postventa',
            width: "1000px",
            showForm: false,
            disabledSave: true
        };

        items = [
            this.gItem({ type: 'number', prop: 'number', label: 'Numero', size: 1, prefix: '#' }),
            this.gItem({ type: 'object', prop: 'dealer_id', label: 'Concesionario', entity: 'dealer', readonly: true, size: 3 }),
            this.gItem({ type: 'object', prop: 'manufacturer_id', label: 'Marca', entity: 'manufacturer', readonly: true, size: 3 }),
            this.gItem({ type: 'text', prop: 'plate', label: 'Placa', size: 2 }),
            this.gItem({ type: 'text', prop: 'vin', label: 'Chasis', size: 3, prefix: '#' }),
            this.gItem({ type: 'text', prop: 'model', label: 'Modelo', size: 3 }),
            this.gItem({ type: 'text', prop: 'city', label: 'Ciudad', size: 3 }),
            this.gItem({ type: 'text', prop: 'ot', label: 'OT', size: 3 }),
            this.gItem({ type: 'text', prop: 'km', label: 'Ultimo kilometraje', size: 3 }),
            this.gItem({ type: 'text', prop: 'customer', label: 'Nombre de Cliente', size: 6 }),
            this.gItem({ type: 'text', prop: 'document', label: 'Documento', size: 3 }),
            this.gItem({ type: 'phone', prop: 'cellphone', label: 'Numero Celular', size: 3 }),
            this.gItem({ type: 'email', prop: 'email', label: 'Email', size: 4 }),
            this.gItem({ type: 'date', prop: 'service_date', label: 'Fecha de Servicio', size: 3 }),
            this.gItem({ type: 'text', prop: 'year', label: 'Anio', size: 1 }),
            this.gItem({ type: 'text', prop: 'month', label: 'Mes', size: 1 }),
            this.gItem({ type: 'text', prop: 'assessor_name', label: 'Asesor', size: 3 }),
            this.gItem({ type: 'text', prop: 'technician_name', label: 'Tecnico', size: 3 }),
            this.gItem({ type: 'object', prop: 'service_type_id', label: 'Tipo de Trabajo', generalType: 'SERVICE_TYPE', size: 3 }),
            this.gItem({ type: 'object', prop: 'payer_id', label: 'Pagador', generalType: 'PAYERS', size: 3 }),
            this.gItem({ type: 'text', prop: 'total', label: 'Facturacion', size: 3 }),
        ]

        get dealer() {
            return this.$store.state.app.dealer;
        }

        get process() {
            return Util.abp.list.getItem(this.$store.state.sale.process);
        }

        initForm() {
            this.modalSetting.title = this.process.name;

            this.items.forEach(item => {
                item.readonly = true;
            });

            if (this.sale.id > 0) {
            } else {
                this.sale.dealer_id = this.dealer;
                this.sale.process_type_id = this.process.id;
            }
        }

        async quizRequest() {
            await this.$store.dispatch({
                type: 'sale/sendQuizRequest',
                data: { id: this.sale.id }
            });

            Util.abp.notify.success(this, 'Notificacion enviada!');
        }

        async save() {
            if ((this.$refs.entityForm1 as any).validate()) {
                let model = Util.extend(true, {}, this.sale);

                await this.$store.dispatch({
                    type: 'sale/' + (this.sale.id > 0 ? 'update' : 'create'),
                    data: model
                });
                this.$emit('save-success');
                this.cancel();
                if (this.sale.id > 0)
                    Util.abp.notify.success(this, 'Registro CEM actualizada!');
                else
                    Util.abp.notify.success(this, 'El Registro CEM ha sido registrado!');
            }
        }

        cancel() {
            this.$emit('input', false);
        }

        async mounted() {
        }

        async created() {
        }
    }
